import React, { SVGProps } from 'react'

const SingleImageIcon: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
    <path d="M.835.835h18.331v18.331H.835z" />
  </svg>
)

export default SingleImageIcon
